// import "./wdyr";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import * as Sentry from "@sentry/react";
import store from "./store";
import App from "./containers/App";
import * as serviceWorker from "./serviceWorker";
import "react-toastify/dist/ReactToastify.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/FontAwesome.css";
import "./assets/css/default.css";
import "./assets/css/style.scss";
import "./assets/css/slick.scss";
import "./assets/css/admin.scss";

// Sentry error tracking
import PromptModal from "./assets/js/promptModal";
import LoadUser from "./components/LoadUser";

if (process.env.REACT_APP_ENVIRONMENT !== "development") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: `clarity@${process.env.REACT_APP_VERSION}`,
  });
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter
      // basename={process.env.REACT_APP_BASE_URL}
      getUserConfirmation={(message, callback) => {
        ReactDOM.render(<PromptModal message={message} callback={callback} />, document.getElementById("modal"));
      }}
    >
      <LoadUser>
        <App />
      </LoadUser>
    </BrowserRouter>
    <ToastContainer position="bottom-right" autoClose={2000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />
  </Provider>,
  document.getElementById("root"),
);
// serviceWorker.register();
serviceWorker.unregister();
